export const getNotifyStatus = state => state.rootReducer.settingsDetails.notificationIsOn;
export const getSpeechStatus = state => state.rootReducer.settingsDetails.speechIsOn;